const fs = require('fs');
const indexPath = 'dist/PanicButton.angular/index.html'; // Ajusta la ruta según sea necesario
const newTitle = process.env.APP_TITLE || 'Controller';

fs.readFile(indexPath, 'utf8', function (err, data) {
  if (err) {
    return console.log(err);
  }

  const result = data.replace(/<title>.*<\/title>/, `<title>${newTitle}</title>`);

  fs.writeFile(indexPath, result, 'utf8', function (err) {
    if (err) return console.log(err);
  });
});
